import { FirebaseError } from 'firebase/app';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from 'utils/firebase';

import { createAppError, notFoundError } from 'api/errors';

interface PostPasswordResetRequest {
  email: string;
}

// 未登録・形式不正は404扱いにし、画面側で送信済と同じ表示にする（アカウント列挙対策）
const ENUMERATION_SAFE_ERROR_CODES = ['auth/user-not-found', 'auth/invalid-email'];

/**
 * Firebase Authentication 標準のパスワード再設定メールを送信する。
 */
export const usePasswordReset = () => {
  const postPasswordReset = async (data: PostPasswordResetRequest): Promise<void> => {
    try {
      auth.languageCode = 'ja';
      await sendPasswordResetEmail(auth, data.email);
    } catch (e) {
      if (e instanceof FirebaseError && ENUMERATION_SAFE_ERROR_CODES.includes(e.code)) {
        throw notFoundError();
      }
      console.error(e);
      throw createAppError(500, 'SendFailed', 'メールの送信に失敗しました。しばらくたってからもう一度お試しください。');
    }
  };

  return { postPasswordReset };
};
